/* CertificationBadge.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _8 = "._1wyboqnp{font-size:.75rem}";
const _7 = "._k48pni7l{font-weight:600}";
const _6 = "._syaz1k3w{color:var(--ds-text-subtle)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Tooltip from '@atlaskit/tooltip';
import { RunsOnAtlassianIcon } from '@atlassian/mpac-primitives';
import { CloudFortifiedAppIcon, CloudSecurityParticipantIcon } from '@atlassian/mpac-ui';
import { TEST_IDS } from '../../primitives/testIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._vwz4kb7n{line-height:1}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._zulp1fcb{gap:var(--ds-space-025)}";
const _2 = "._1yt4djrq{padding:var(--ds-space-050) var(--ds-space-0)}";
const _ = "._1e0c1txw{display:flex}";
const CertificationBadgeContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1yt4djrq _zulp1fcb _4cvr1h6o _vwz4kb7n", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CertificationBadgeContainer.displayName = 'CertificationBadgeContainer';
}
const Text = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1k3w _k48pni7l _1wyboqnp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Text.displayName = 'Text';
}
const badge = {
  CLOUD_FORTIFIED: {
    icon: /*#__PURE__*/_jsx(CloudFortifiedAppIcon, {
      label: "Cloud Fortified App Badge",
      size: "small"
    }),
    text: 'CLOUD FORTIFIED',
    tooltip: 'Apps that meet all cloud security and reliability requirements'
  },
  CLOUD_SECURITY_PARTICIPANT: {
    icon: /*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
      label: "Cloud Security Participant App Badge",
      primaryColor: "var(--ds-icon-brand)",
      size: "small"
    }),
    text: 'CLOUD SECURITY PARTICIPANT',
    tooltip: 'App is enrolled in the Marketplace Bug Bounty Program'
  },
  RUNS_ON_ATLASSIAN: {
    icon: /*#__PURE__*/_jsx(RunsOnAtlassianIcon, {
      label: "Runs on Atlassian Badge",
      size: "small"
    }),
    text: 'RUNS ON ATLASSIAN',
    tooltip: 'Apps that run on same infrastructure as Atlassian products'
  }
};
export const CertificationBadge = props => {
  const {
    icon,
    text,
    tooltip
  } = badge[props.certification];
  return /*#__PURE__*/_jsx(Tooltip, {
    content: tooltip,
    position: "bottom-start",
    children: /*#__PURE__*/_jsxs(CertificationBadgeContainer, {
      "data-testid": TEST_IDS.CERTIFICATION_BADGE,
      children: [icon, /*#__PURE__*/_jsx(Text, {
        children: text
      })]
    })
  });
};